import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Home  from './components/web_development/Home';
import DashboardHome from './components/dashboard/DashboardHome';
import DatabaseMigrationHome from './components/database_migration/DatabaseMigrationHome';
import Analytics_Home from './components/bi_analytics/Analytics_Home';
import CloudMgmtHome from './components/cloud_management/CloudMgmtHome';
import CloudMigrationHome from './components/cloud_migration/CloudMigrationHome';
import CloudConsultationHome from './components/cloud_consulation/CloudConsultationHome';
import FlintAboutUs from './components/about/FlintAboutUs';
import TagManager from 'react-gtm-module'
import Contact from './components/common/Contact';
import Upload from './components/upload';
import Disclaimer from './components/Disclaimer';
import PrivacyPolicy from './components/PrivacyPolicy';
import VoterSync from './components/products/VoterSync';

const tagManagerArgs = {
  gtmId: 'G-VECN8SXLLB'
}

TagManager.initialize(tagManagerArgs);

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <DashboardHome />
      },
      {
        path: "/web-development",
        element: <Home />,
      },
      {
        path: "/database-migration",
        element: <DatabaseMigrationHome />,
      },
      {
        path: "/bi-analytics",
        element: <Analytics_Home />,
      },
      {
        path: "/cloud-management",
        element: < CloudMgmtHome />,
      },
      {
        path: "/cloud-migration",
        element: <CloudMigrationHome />
      },
      {
        path: "/cloud-consultation",
        element: <CloudConsultationHome />
      },
      {
        path: "/about",
        element: <FlintAboutUs />
      },
      {
        path: "/contact-us",
        element: <Contact />
      },
      {
        path: "/disclaimer",
        element: <Disclaimer />
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />
      },
      {
        path: "/contact-us",
        element: <Contact />
      },
      {
        path: "/upload",
        element: <Upload />
      },
      {
        path: "/products/votersync",
        element: <VoterSync />
      }

    ]
  },
]);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={appRouter} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
